// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"b6-z"};